/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */

App.ready(() => App.pagination.init());

App.pagination = {
  init() {
    return $(document)
      .off("change", ".js-pagination-per-select", this.per_changed)
      .on("change", ".js-pagination-per-select", this.per_changed);
  },


  per_changed(evt) {
    evt.preventDefault();
    const usp = new URLSearchParams(location.search);
    usp.set('per', evt.target.value);
    return location.href = location.origin + location.pathname + '?' + usp.toString();
  }
};
